import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, OnDestroy, OnInit, Output, Renderer2 } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { ReplaySubject, Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { currencysymbolPrefix } from '../../../../_enums';
import { AppConfig, CustomValidators, DataService, ParameterData } from '../../../../_helpers';
import { Account, Debtor } from '../../../../_models';
import { CustomerService, DebtorDataService, DebtorService, InvoicesService } from '../../../../_services';
import { AccountTypeOptions } from '../../../../sharedcomp/constans/routes.constans';
import { icons } from '../../../../sharedcomp/constans/icons.constans';
import { MatSelectChange } from '@angular/material';

@Component({
  selector: 'app-new-invoices-creation',
  templateUrl: './new-invoices-creation.component.html',
  styleUrls: ['./new-invoices-creation.component.css', '../../../../../assets/css/new-component-view.css', '../../../../../assets/css/new-buttons-theme.css'],
  animations: [
    trigger('animationDisplay', [
      state('visible-fields', style({ maxHeight: '500px' })),
      state('hide-fields', style({ maxHeight: '0' })),
      transition('visible-fields => hide-fields', animate('300ms ease-out')),
      transition('hide-fields => visible-fields', animate('300ms ease-in')),
    ])
  ],
  providers: [Ng4LoadingSpinnerService]
})
export class NewInvoicesCreationComponent implements OnInit, OnDestroy {

  public customer_public_id: string;
  public user_public_id: string;
  public buttonValidate = false;

  public invoicePublic_key: string;
  public cusAccountPublicKey_temp: Account[] = [];
  public cusAccountPublicKey_ntemp: Account[] = [];
  public cusDebtor: Debtor[] = [];
  public invoiceForm: FormGroup;
  public duedatetime: string;
  public name: string;
  submitted = false;
  due_datetime: any;
  ddltotalCurrencySymbol: string[];
  ddlLatefeeCurrencySymbol: string[];
  statusValue: any;
  isalertVisiable = false;

  isalertExist = false;
  statusExist;
  existLinkID;

  minDate: any;
  maxDate: any;
  offsetTimeZone: any;
  offsetMinutes: number;
  offsetTimeVal: any;
  customerSearch: FormControl = new FormControl();
  filteredValue: ReplaySubject<Debtor[]> = new ReplaySubject<Debtor[]>(1);
  private _onDestroy = new Subject<void>();
  searching: boolean = false;
  noEntriesFoundLabel = "No results matched";
  preSelectDebtorDate: any;
  customerFilterData: any[] = [];

  // Variable to show if invoice editing fails
  isErrorVisible: boolean;
  statusError: string;
  // Variable that will send the currency value to the accordion to set the form.
  currencySymbolInput: string;
  // Variable that will send the customer public Id Input() to the accordion.
  customerPublicIdInput: string;
  // Variable to indicate whether the account is CORPORATE or PAYMENTS
  APP: string;

  today;
  isDueDatetime: boolean = true;

  extraFieldsState: 'visible-fields' | 'hide-fields' = 'hide-fields';
  @Output() cancelCreation: EventEmitter<boolean> = new EventEmitter();

  icons: Record<string, Record<string, string>>;

  /** This is Constructor function which is used to initialize the class variables and objects;
  */
  constructor(
    private router: Router, private _fb: FormBuilder
    , private parameterData: ParameterData
    , private dataService: DataService
    , private invoicesService: InvoicesService
    , private customerService: CustomerService
    , private _currencysymbolPrefix: currencysymbolPrefix
    , private debtorDataService: DebtorDataService
    , private debtorService: DebtorService
    , private renderer: Renderer2
    , private spinnerService: Ng4LoadingSpinnerService
  ) {
    this.debtorDataService.getPreSelectDebtorSharedData()
      .pipe(takeUntil(this._onDestroy))
      .subscribe(data => this.preSelectDebtorDate = data);

    this.icons = icons;

    if (this.parameterData.InvoiceIdParameters !== null) {
      this.invoicePublic_key = this.parameterData.InvoiceIdParameters;
      this.parameterData.InvoiceIdParameters = null;
    } else {
      this.invoicePublic_key = "invoice Key";
    }

    this.isalertVisiable = false;

    this.ddltotalCurrencySymbol = _currencysymbolPrefix.currencyPrefix;
    this.ddlLatefeeCurrencySymbol = _currencysymbolPrefix.currencyPrefix;

    const now = new Date();
    const todayDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    this.minDate = todayDate;

    const lastDate = new Date(2050, 11, 31);
    this.maxDate = lastDate;
    this.initialSetup();
  }

  /** This is ngOnInit function called after initialising the component; */
  ngOnInit() {

    this.APP = localStorage.getItem('application');
    let browserStorage;
    let browserStorage1 = (localStorage.getItem('isCorporate') === 'undefined') ? null : localStorage;
    if (browserStorage1 == null) {
      browserStorage = localStorage.getItem('companyId');
      if (browserStorage === null || browserStorage === '' || browserStorage === undefined) {
        this.router.navigate(['/home']);
      } else {
        this.customer_public_id = localStorage.getItem('companyId');
        this.user_public_id = localStorage.getItem('userId');
      }
    } else {
      this.customer_public_id = localStorage.getItem('subcompanyId');
      this.user_public_id = localStorage.getItem('userId');
    }

    browserStorage = (typeof localStorage === 'undefined') ? null : localStorage;

    this.offsetTimeZone = (typeof browserStorage.getItem('timezone') === 'undefined') ? null : browserStorage.getItem('timezone');
    this.offsetMinutes = 0;
    if (this.offsetTimeZone == null || this.offsetTimeZone === 'undefined' || Number.isNaN(this.offsetTimeZone)) {
      this.offsetTimeZone = -5.00;
    } else {
      this.offsetTimeZone = browserStorage.getItem('timezone');
    }
    this.offsetTimeVal = (this.offsetTimeZone * 3600000);
    AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;

    if (this.preSelectDebtorDate !== undefined && this.preSelectDebtorDate !== null && this.preSelectDebtorDate !== 0) {
      this.getDebtor(this.preSelectDebtorDate.public_id);
    }

    this.customerPublicIdInput = this.customer_public_id;

    setTimeout(() => {
      this.getCustomerAccountList();
    }, 500);

    this.customerSearch
      .valueChanges
      .pipe(debounceTime(500),
        takeUntil(this._onDestroy))
      .subscribe(() => {
        this.search();
      });

    this.invoiceForm.enable();
    this.today = moment(new Date()).format('YYYY/MM/DD');
    this.disabledControls();
  }

  getDebtor(preSelectDebtorDate) {
    this.debtorService.getDebtor(preSelectDebtorDate)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: Debtor) => {
        if (data.status === 'ACTIVE') {
          const tempPreSelectData = [{ name: this.preSelectDebtorDate.name, public_id: this.preSelectDebtorDate.public_id }]
          this.filteredValue.next(tempPreSelectData);
          this.invoiceForm.get('debtor.public_id').setValue(this.preSelectDebtorDate.public_id);
          this.debtorDataService.setPreSelectDebtorSharedData(null);
        }
      })
  }

  getCustomerAccountList() {
    this.customerService.getCustomerAccountList(this.customer_public_id)
      .pipe(takeUntil(this._onDestroy))
      .subscribe(data => {
        this.cusAccountPublicKey_temp = data;
        if (this.APP === "PAYOUTS") {
          this.cusAccountPublicKey_temp = this.cusAccountPublicKey_temp.filter((t => t.type === 'PAYABLE'));
        } else {
          this.cusAccountPublicKey_temp = this.cusAccountPublicKey_temp.filter((t => t.type === 'COLLECT' || t.type === 'RECEIVABLE'));
        }
        const cusAccountPublicKey_tempLength = this.cusAccountPublicKey_temp.length;
      });
  }

  setCurrency(form: FormGroup, parameter: string) {
    form.get('late_fee.currency').setValue(parameter);
    form.get('fees.currency').setValue(parameter);
    form.get('sub_total.currency').setValue(parameter);
    form.get('total.currency').setValue(parameter);
  }

  disabledControls() {
    this.invoiceForm.get('late_fee.currency').disable();
    this.invoiceForm.get('fees.currency').disable();
    this.invoiceForm.get('total.currency').disable();
    this.invoiceForm.get('total.value').disable();
    if (this.isDueDatetime) {
      this.invoiceForm.get('late_fee.value').disable();
    }
  }

  initialSetup() {

    const currentDueDate = new Date();
    const currentExpDate = new Date();

    this.duedatetime = currentDueDate.toString();

    this.invoiceForm = this._fb.group({
      invoice_id: new FormControl(""),
      metadata: this._fb.group({
        order_id: new FormControl(""),
        order_name: new FormControl("", Validators.required),
        order_description: new FormControl("", Validators.maxLength(250))
      }),
      debtor: this._fb.group({
        public_id: new FormControl("", Validators.required),
        external_id: new FormControl(""),
        name: new FormControl(""),
        phone: new FormControl(""),
        email: new FormControl(""),
        document_type: new FormControl(""),
        document_id: new FormControl(""),
      }),
      total: this._fb.group({
        currency: new FormControl("Seleccione", Validators.required),
        value: new FormControl(0, [Validators.required, CustomValidators.total])
      }),
      due_datetime: new FormControl(new Date(currentDueDate)),
      late_fee: this._fb.group({
        currency: new FormControl("Seleccione"),
        value: new FormControl(0)
      }),
      expiration_datetime: new FormControl(new Date(currentExpDate.setDate(currentExpDate.getDate() + 30))),
      creditor_account: this._fb.group({
        public_id: new FormControl("")
      }),
      user: this._fb.group({
        public_id: new FormControl("")
      }),
      sub_total: this._fb.group({
        currency: new FormControl("Seleccione", [Validators.required, this.validateSubTotal.bind(this)]),
        value: new FormControl(0, [Validators.required])
      }),
      fees: this._fb.group({
        currency: new FormControl("Seleccione"),
        value: new FormControl(0)
      })

    });
  }

  validateSubTotal(control: FormControl): { [key: string]: any } | null {
    const selectedValue = control.value;
    if (selectedValue && selectedValue.toLowerCase() === 'seleccione') {
      return { invalidSubTotal: true };
    }
    return null;
  }


  addDueDateTimeEvent(event) {
    if (event.value !== null) {
      const dueDatetimeSelected = moment(event.value).format('YYYY/MM/DD');
      const daysDifference = moment(dueDatetimeSelected).diff(moment(this.today), 'days');

      if (Math.sign(daysDifference) === -1) {
        this.isDueDatetime = false;
        this.invoiceForm.get('late_fee.value').enable();
      } else {
        this.isDueDatetime = true;
        this.invoiceForm.get('late_fee.value').setValue(0);
        this.invoiceForm.get('late_fee.value').disable();
      }

    } else {
      this.isDueDatetime = true;
      this.invoiceForm.get('late_fee.value').disable();
    }
  }

  async search() {
    if (this.customerSearch.value.length > 2) {
      this.invoiceForm.get('debtor.public_id').setValue('');
      this.searching = true;
      this.noEntriesFoundLabel = "No results matched " + '"' + this.customerSearch.value + '"';
      try {
        const data = await this.customerService.getCustomerListBySearch(this.customer_public_id, this.customerSearch.value).toPromise();
        this.customerFilterData = data.data;
        this.filteredValue.next(this.customerFilterData.filter(item => item.status == 'ACTIVE'));
        this.searching = false;
      }
      catch (error) {
        console.error('Failed while trying to get the customer list.' + error.error)
      }
    }
  }

  convertISO(convertExpDate) {

    const a = convertExpDate.split(/[- :]/),
      isoDate = new Date(a[0], a[1] - 1, a[2], a[3], a[4], a[5]);

    return new Date(isoDate).toISOString();
  }

  checkCurrencyDetails(value) {
    if (this.invoiceForm.get('total.currency').value !== value) {
      alert("Please select the Currency same Mora and Monto")
    }
  }

  setSubTotalValueForm(event: KeyboardEvent) {
    let subTotal: number | string = (event.target as HTMLInputElement).value;

    // When the field is empty and has no value, any of these cases
    // can result, so it is assigned the value 0
    if (isNaN(parseInt(subTotal)) || !subTotal || subTotal === "") {
      subTotal = 0;
    }

    // I obtain the values of late_ fee and fees and then with the value of sub_total I make the
    // calculation and assign this new value to total.
    const late_fee = this.invoiceForm.get('late_fee.value').value;
    const fees = this.invoiceForm.get('fees.value').value;

    // parseFloat() is used instead of parseInt() to handle decimals.
    const result = parseFloat(subTotal.toString()) + parseFloat(late_fee) + parseFloat(fees);
    this.invoiceForm.get('total.value').setValue(result);
  }

  setSubTotalCurrencyForm(event: MatSelectChange) {
    const sub_total = event.value;
    this.currencySymbolInput = sub_total;
    this.invoiceForm.get('late_fee.currency').setValue(sub_total);
    this.invoiceForm.get('fees.currency').setValue(sub_total);
    this.invoiceForm.get('total.currency').setValue(sub_total);
  }

  setLateFeeValueForm(event: KeyboardEvent) {
    let lateFee: number | string = (event.target as HTMLInputElement).value;
    // When the field is empty and has no value is assigned the value 0
    if (isNaN(parseFloat(lateFee))) {
      lateFee = 0;
    }

    const fees = this.invoiceForm.get('fees.value').value;

    // When the field is empty and has no value, any of these cases
    // can result, so it is assigned the value 0
    let subTotal = this.invoiceForm.get('sub_total.value').value;
    if (isNaN(parseFloat(subTotal)) || !subTotal || subTotal === "") {
      subTotal = 0;
    }

    subTotal = Number(subTotal);

    // I obtain the values of late_ fee and fees and then with the value of sub_total I make the
    // calculation and assign this new value to total.
    // parseFloat() is used instead of parseInt() to handle decimals.
    const result = parseFloat(subTotal) + parseFloat(lateFee.toString()) + parseFloat(fees);
    this.invoiceForm.get('total.value').setValue(result);
  }

  setFeesValueForm(event: KeyboardEvent) {
    let fees: number | string = (event.target as HTMLInputElement).value;

    // When the field is empty and has no value is assigned the value 0
    if (isNaN(parseFloat(fees))) {
      fees = 0;
    }

    const lateFee = this.invoiceForm.get('late_fee.value').value;

    // When the field is empty and has no value, any of these cases
    // can result, so it is assigned the value 0
    let subTotal = this.invoiceForm.get('sub_total.value').value;
    if (isNaN(parseFloat(subTotal)) || !subTotal || subTotal === "") {
      subTotal = 0;
    }

    subTotal = Number(subTotal);

    // I obtain the values of late_ fee and fees and then with the value of sub_total I make the
    // calculation and assign this new value to total.
    // parseFloat() is used instead of parseInt() to handle decimals.
    const result = parseFloat(subTotal) + parseFloat(lateFee) + parseFloat(fees.toString());
    this.invoiceForm.get('total.value').setValue(result);
  }

  formatDate(date) {
    const momentObjexp = moment(date);
    const expDate = momentObjexp.format("YYYY-MM-DD 00:00:00");
    return this.convertGMTTime(expDate);
  }

  createInvoice(invoiceForm) {
    this.invoicesService.createInvoice(invoiceForm)
      .pipe(takeUntil(this._onDestroy))
      .subscribe({
        next: result => {
          const resultId = result["body"];
          const status = Number(result.status);
          if (status === 200) {
            this.statusExist = "Orden de Pago con este ID ya existe";
            this.isalertExist = true;
            this.existLinkID = resultId.public_id;
          } else if (status === 202) {
            if (result["body"]) {
              this.statusError = result["body"];
              this.isErrorVisible = true;
            }
          } else {
            this.invoiceForm.reset();
            this.invoiceForm.enable();
            if (AccountTypeOptions[this.APP] != undefined) {
              this.router.navigate([`/${AccountTypeOptions[this.APP]}/invoices/${resultId.public_id}/view`]);
            }
          }
          this.spinnerService.hide();
        }, error: err => {
          const status = Number(err.status);
          if (status === 400) {
            this.statusError = err.error;
            if (err.error && err.error.Description) {
              this.statusError = err.error.Description;
            } else {
              this.statusError = "Error al crear la orden de pago";
            }
            this.isErrorVisible = true;
          }
          console.error('Failed while trying to create the Invoice Details.' + err);
          this.spinnerService.hide();
        }
      });
  }

  /** This is onsubmit function called for all Invoice Data Save/Update Component;
   */
  onsubmit() {
    this.spinnerService.show();
    const value = this.invoiceForm.getRawValue();
    this.buttonValidate = true;

    this.cusAccountPublicKey_ntemp = this.cusAccountPublicKey_temp.filter((t => t.balance.currency === value.total.currency));
    value.creditor_account.public_id = this.cusAccountPublicKey_ntemp[0].public_id;

    const debtorInfo = this.customerFilterData.find(debtor => debtor.public_id === value.debtor.public_id);
    if (debtorInfo) {
        value.debtor.external_id = debtorInfo.external_id;
        value.debtor.name = debtorInfo.name;
        value.debtor.phone = debtorInfo.phone;
        value.debtor.email = debtorInfo.email;
        value.debtor.document_type = debtorInfo.document_type;
        value.debtor.document_id = debtorInfo.document_id;
    }
    
    const dateObjexp = new Date(value.expiration_datetime);

    value.due_datetime = this.formatDate(value.due_datetime).replace(' ', 'T');
    value.expiration_datetime = this.formatDate(dateObjexp).replace(' ', 'T');
    
    if (value.total.currency === 'S/.') {
      value.late_fee.currency = 'PEN';
      value.total.currency = 'PEN';
    }

    if (value.total.currency === 'US$') {
      value.late_fee.currency = 'USD';
      value.total.currency = 'USD';
    }

    value.late_fee.value = Number(value.late_fee.value);
    value.total.value = Number(value.total.value);
    value.user.public_id = this.user_public_id;

    if (value.id === null) {
      value.id = 0;
    }

    value.late_fee.currency = value.total.currency;

    if (value.total.currency === value.late_fee.currency) {
      this.createInvoice(value);
    }
  }

  /****GMT Converstion */
  convertGMTTime(convertDate) {
    const dateTimeZoneDiff = convertDate.split(/[- :]/),
      startDateFinal = new Date(dateTimeZoneDiff[0], dateTimeZoneDiff[1] - 1, dateTimeZoneDiff[2], dateTimeZoneDiff[3], dateTimeZoneDiff[4], dateTimeZoneDiff[5]);
    if (this.offsetTimeZone > 0) {
      this.offsetMinutes = 30;
      const startDate2 = new Date(startDateFinal.setHours(startDateFinal.getHours() - this.offsetTimeZone));
      const startDate3 = new Date(startDate2.setMinutes(startDate2.getMinutes() - this.offsetMinutes) + 720000);
      let tempDate = moment(startDate3).format('YYYY-MM-DD HH:mm:ss');
      return tempDate;
    }
    else {
      const startDate4 = new Date(startDateFinal.setHours(startDateFinal.getHours() - this.offsetTimeZone));
      const startDate5 = new Date(startDate4.setMinutes(startDate4.getMinutes() - this.offsetMinutes));
      let tempDate1 = moment(startDate5).format('YYYY-MM-DD HH:mm:ss');
      return tempDate1;
    }
  }

  viewInvoiceList() {
    if (AccountTypeOptions[this.APP] != undefined) {
      this.router.navigate([`/${AccountTypeOptions[this.APP]}/invoices`]);
    }
  }

  viewInvoiceDetails() {
    if (AccountTypeOptions[this.APP] != undefined) {
      this.router.navigate([`/${AccountTypeOptions[this.APP]}/invoices/${this.existLinkID}/view`]);
    }
  }

  closeCreateInvoiceSidebar() {
    this.cancelCreation.emit(false);
  }

  toggleElement() {
    this.extraFieldsState = this.extraFieldsState === 'hide-fields' ? 'visible-fields' : 'hide-fields';
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'modal-open');
    this.dataService.changeinvoicepublicKey('invoice Key');
    this._onDestroy.next();
    this._onDestroy.complete();
  }

}
